import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";

import { isPremium } from "../../../../isomorphic/data/story";

import styles from "./styles.m.css";
import { getStoryData, generateImageSources, checkAppSlug } from "../../utils/utils";
import Icon from "../icon";
import Contributor from "../contributor";

const BigStoryCardCurve = ({
  story,
  cardWithImageZoom = true,
  className = "",
  hasTruncatedHeadline = true,
  bigimage = true,
  pFrom = "big-card",
  iconbottomright = false,
  videocard = false,
  bighorizontalcard,
  textOverleyCard = false
}) => {
  const storyData = getStoryData(story, false);

  const contributor = get(story, ["authors", 0], {});
  const contributorRole = get(story, ["authors", 0, "contributor-role", "name"], "");

  const externalLink = get(story, ["metadata", "reference-url"]);
  const checkSlug = checkAppSlug();
  let SourceLink = "";

  if (checkSlug) {
    SourceLink = externalLink || story.url;
  }

  if (!(storyData.headline && story.url)) {
    return null;
  }

  const icons = {
    "photo-album": "",
    photo: "",
    video: "video-play"
  };
  const iconType = get(icons, [story["story-template"]], null);

  return (
    <Link
      aria-label={`${"Read full story: "} ${storyData.headline}`}
      className={`${styles["read-more-link"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""} ${
        videocard ? styles["hasvideobigcard"] : styles["hasnotvideobigcard"]
      } ${bighorizontalcard ? styles["bighorizontalcard"] : ""} ${textOverleyCard ? styles["textoverleycard"] : ""}`}
      href={`${externalLink || story.url}?pfrom=${pFrom}`}
      externalLink={SourceLink || externalLink}
    >
      <div
        className={`${styles["base"]} ${bigimage ? styles["fullheightimage"] : ""} ${
          iconbottomright ? styles["hasicon"] : styles["hasnoticon"]
        }`}
      >
        <div className={styles["image-with-icon"]}>
          <ResponsiveImageWithFallback
            className={styles["image-wrapper"]}
            slug={storyData.imageS3Key}
            metadata={storyData.imageMetadata}
            isPremium={isPremium(story)}
            alt={storyData.imageCaption}
            imgParams={{ auto: ["format", "compress"] }}
            sources={generateImageSources(
              { aspectRatio: [30, 18], screenWidthCoverage: 0 },
              { aspectRatio: [9, 6], screenWidthCoverage: 0.25 }
              // { aspectRatio: [9, 6], screenWidthCoverage: 0.5 },
              // { aspectRatio: [9, 6], screenWidthCoverage: 0.25 }
            )}
            story={story}
          />
          {iconbottomright &&
            iconType && (
              <span className={styles["story-template-icon"]}>
                <Icon type={iconType} className={styles["template-icon"]} />
              </span>
            )}
        </div>
        <div className={styles["text-wrapper"]}>
          <div>
            <h3 className={`${styles["headline"]} ${hasTruncatedHeadline ? styles["truncated"] : ""} `}>
              {storyData.headline}
            </h3>
            {bighorizontalcard && (
              <div className={`${styles["sub-headline"]} ${hasTruncatedHeadline ? styles["truncated"] : ""} `}>
                {storyData.subheadline}
              </div>
            )}
          </div>
          {bighorizontalcard && (
            <Contributor name={contributor["name"]} type={contributorRole} className={`${styles["contributor"]}`} />
          )}
        </div>
      </div>
    </Link>
  );
};

BigStoryCardCurve.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  className: PropTypes.string,
  hasTruncatedHeadline: PropTypes.bool,
  bigimage: PropTypes.bool,
  textOverleyCard: PropTypes.bool,
  story: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  }),
  pFrom: PropTypes.string,
  iconbottomright: PropTypes.bool,
  videocard: PropTypes.bool,
  bighorizontalcard: PropTypes.bool
};

export default BigStoryCardCurve;
